__webpack_require__.p = "/cryptoapp/";